@if(warningDialog) {
<div class="modal-header">
  <div>
    <h4
      class="modal-title text-danger d-flex align-items-center"
      id="modal-title"
    >
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ title }}
    </h4>
  </div>
  <i
    class="bi bi-x-lg text-danger ms-auto"
    role="button"
    (click)="onCancel()"
    title="Close"
  ></i>
</div>
<div class="modal-body text-grey">
  <p>You are about to switch the <strong>Authentication Mechanism</strong>.</p>
  <p class="mb-2">
    Before proceeding, please ensure that this administrator account exists in
    the <strong>new authentication provider</strong>, or add a user (that exists
    in the new provider) to the SyncHPC application with
    <strong>administrator privileges</strong>.
  </p>

  <div class="alert alert-danger" role="alert">
    If no such user is mapped, you may lose access to the SyncHPC UI.
  </div>

  <p>
    To manually recover access, update the <code>AuthType</code> value to
    <code>'0'</code> in:
  </p>
  <pre class="bg-light p-2 rounded text-wrap">
/opt/synchpchost/wwwroot/SyncHpcScripts/SyncHpcConfig.xml
  </pre>
  <p>
    Do you want to change authentication type from
    {{ warningDialogContent.originalAuthType }} to
    {{ warningDialogContent.newAuthType }}?
  </p>
  <div class="form-check my-3" style="display: flex; align-items: center">
    <input class="form-check-input" type="checkbox" id="adminConfirmed" />
    <label
      class="form-check-label"
      for="adminConfirmed"
      style="margin-left: 10px"
    >
      I confirm that an admin account is mapped in the new provider.
    </label>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
    Close
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
    cdkFocusInitial
  >
    I Understand
  </button>
</div>
} @else{

<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">
    {{ title }}
  </h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onCancel()"
    title="Close"
  ></i>
</div>
<div class="modal-body text-grey">
  <p>
    {{ message }}
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
    Close
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
    cdkFocusInitial
  >
    Yes
  </button>
</div>
}
